// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sign-canvas[data-v-30cc069f]{border:1px solid #ff787f}", ""]);
// Exports
module.exports = exports;
